export enum VerificationType {
  SMS = 'SMS',
  EMAIL = 'EMAIL',
}

export enum PhoneVerificationStep {
  ENTER_PHONE_NUMBER = 'ENTER_PHONE_NUMBER',
  PHONE_VERIFICATION_CODE = 'PHONE_VERIFICATION_CODE',
  PHONE_VERIFIED_SUCCESSFULLY = 'PHONE_VERIFIED_SUCCESSFULLY',
}

export enum EmailVerificationStep {
  ENTER_EMAIL = 'ENTER_EMAIL',
  EMAIL_VERIFICATION_CODE = 'EMAIL_VERIFICATION_CODE',
  EMAIL_VERIFIED_SUCCESSFULLY = 'EMAIL_VERIFIED_SUCCESSFULLY',
}

export enum VerificationServerError {
  EMAIL_ALREADY_VERIFIED = 'Email is already verified',
  PHONE_NUMBER_ALREADY_VERIFIED = 'Phone number is already verified',
  CODE_RESEND_TIMEOUT_ERROR = 'Cannot generate a new verification code within 60 seconds of the last one',
}

export enum VerificationErrorText {
  CODE_IS_INVALID = 'Code is invalid',
  EMAIL_ADDRESS_IS_ALREADY_VERIFIED = 'This email address is already verified',
  PHONE_NUMBER_IS_ALREADY_VERIFIED = 'This phone number is already verified',
  CODE_RESEND_TIMEOUT_ERROR = 'Cannot generate a new verification code within 60 seconds of the last one',
  OTHER_ERROR = 'Please try again later',
}
